import React from "react";
import "./Support.css";

const Support = () => {
  const supportCards = [
    {
      id: "call-us",
      tag: "Call Us",
      title: "1800 102 8411",
      subtext: "Toll Free",
      desc: "Mon – Sun, 9 AM – 9 PM",
      linkText: "Tap to call",
      linkUrl: "tel:18001028411",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="support-icon"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-2.824-1.802-5.122-4.1-6.924-6.924l1.293-.97a1.125 1.125 0 0 0 .417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z"
          />
        </svg>
      ),
    },
    {
      id: "whatsapp",
      tag: "WhatsApp",
      title: "Chat on WhatsApp",
      subtext: "Instant Messaging",
      desc: "Share media files for easy support",
      linkText: "Get started",
      linkUrl: "https://wa.me/9118001028411",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="support-icon"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z"
          />
        </svg>
      ),
    },
    {
      id: "live-chat",
      tag: "Live Chat",
      title: "Chat Support",
      subtext: "Active Agents",
      desc: "Mon – Sun, 9 AM – 9 PM",
      linkText: "Get started",
      linkUrl: "#",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="support-icon"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v5.518Z"
          />
        </svg>
      ),
    },
  ];

  const secondaryCard = {
    id: "email-us",
    tag: "Email Us",
    title: "support@shyenatechyarns.in",
    subtext: "Online Helpdesk",
    desc: "Response within 24 hours",
    linkText: "Send email",
    linkUrl: "mailto:support@shyenatechyarns.in",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className="support-icon"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
        />
      </svg>
    ),
  };

  return (
    <div className="support-container">
      {/* Header section - using div to avoid global flex collisions */}
      <div className="support-header">
        <span className="support-category">Shyena Tech Yarns · Support</span>
        <h1 className="support-title">Contact Us</h1>
        <p className="support-subtitle">
          We're here to help. Reach out through any channel.
        </p>

        {/* Custom Premium Divider with active blue central dot */}
        <div className="support-divider-wrapper">
          <div className="support-divider-line">
            <div className="support-divider-dot"></div>
          </div>
        </div>
      </div>

      {/* Main Grid for first 3 cards */}
      <section className="support-grid">
        {supportCards.map((card) => (
          <article className="support-card" key={card.id}>
            <div className="support-icon-container">{card.icon}</div>
            <span className="support-card-tag">{card.tag}</span>
            <h2 className="support-card-title">{card.title}</h2>
            <p className="support-card-subtext">{card.subtext}</p>
            <p className="support-card-desc">{card.desc}</p>
            <a
              href={card.linkUrl}
              className="support-card-link"
              target={card.linkUrl.startsWith("http") ? "_blank" : "_self"}
              rel="noopener noreferrer"
            >
              {card.linkText} <span>→</span>
            </a>
          </article>
        ))}
      </section>

      {/* Secondary layout for the 4th card (Email Us) */}
      <section className="support-row-secondary">
        <div className="support-card-wrapper">
          <article className="support-card">
            <div className="support-icon-container">{secondaryCard.icon}</div>
            <span className="support-card-tag">{secondaryCard.tag}</span>
            <h2 className="support-card-title">{secondaryCard.title}</h2>
            <p className="support-card-subtext">{secondaryCard.subtext}</p>
            <p className="support-card-desc">{secondaryCard.desc}</p>
            <a href={secondaryCard.linkUrl} className="support-card-link">
              {secondaryCard.linkText} <span>→</span>
            </a>
          </article>
        </div>
      </section>
    </div>
  );
};

export default Support;
